import { Color } from '@styles/theme';

import { request } from '../request';
export type WorkspaceIconName =
  | 'IconWorkspace'
  | 'IconAI'
  | 'IconBulk'
  | 'IconBoolean'
  | 'IconContract'
  | 'IconCompany'
  | 'IconDate'
  | 'IconDocument'
  | 'IconPerson'
  | 'IconTeam'
  | 'IconPersonAdd'
  | 'IconPersonRemove'
  | 'IconFile'
  | 'IconReport'
  | 'IconReject'
  | 'IconStar'
  | 'IconPinned'
  | 'IconPin'
  | 'IconEmail'
  | 'IconStages'
  | 'IconTemplate'
  | 'IconInternalTasklist'
  | 'IconSms'
  | 'IconSSO'
  | 'IconScorecard'
  | 'IconStatistics'
  | 'IconSection'
  | 'IconWorkspaceAlt'
  | 'IconTime'
  | 'IconOnboarding'
  | 'IconMove'
  | 'IconPersonDetails'
  | 'IconMarketplace'
  | 'IconLocation'
  | 'IconLanguage'
  | 'IconListDynamic'
  | 'IconList'
  | 'IconGroup'
  | 'IconLibrary'
  | 'IconLabel'
  | 'IconJob'
  | 'IconJobboard'
  | 'IconIssues'
  | 'IconImage'
  | 'IconIntegration'
  | 'IconInbox'
  | 'IconHourglass'
  | 'IconHelp'
  | 'IconFilter'
  | 'IconForm'
  | 'IconFolder'
  | 'IconFiles'
  | 'IconElement'
  | 'IconEndpoint'
  | 'IconEducation'
  | 'IconEqualsNot'
  | 'IconFixPosOn'
  | 'IconInput'
  | 'IconLoop'
  | 'IconSend'
  | 'IconModeLight'
  | 'IconModeDark'
  | 'IconSelectMultiple'
  | 'IconZoomIn';

export type Workspace = {
  shortId: string;
  title: string;
  description: string;
  icon: WorkspaceIconName;
  color: Color;
  dateCreated: string;
  dateUpdated: string;
  isPrivate: boolean;
  members: string[];
};

export const loadWorkspaces = async () => {
  const response = await request.get<Workspace[]>('v1/workspaces/');
  return response.data;
};

export const loadWorkspace = async (shortId: string) => {
  const response = await request.get<Workspace>(`v1/workspaces/${shortId}/`);
  return response.data;
};

export type WorkspaceData = {
  title: string;
  description: string;
  icon: string;
  color: string;
  isPrivate: boolean;
  members: string[];
};

export const createWorkspace = async (data: WorkspaceData) => {
  const response = await request.post('v1/workspaces/', data);
  return response.data;
};

export const updateWorkspace = async (shortId: string, data: WorkspaceData) => {
  const response = await request.patch(`v1/workspaces/${shortId}/`, data);
  return response.data;
};

export const deleteWorkspace = async (shortId: string) => {
  const response = await request.delete(`v1/workspaces/${shortId}/`);
  return response.data;
};

export const getWorkspaceJourneysCount = async (workspaceId: string) => {
  const response = await request.get<{ count: number }>(
    `v1/workspaces/${workspaceId}/journeys_count/`
  );
  return response.data.count;
};
